export default __webpack_public_path__ + "static/media/hoppia_about_02.181da1c9.png";